import React from "react";
export function Footer() {
  return <footer className="bg-plum-950 px-5 pb-32 pt-10 text-center text-plum-200" data-id="element-130" data-mp="32wmqrybuniwl">
      <p className="font-display text-lg font-extrabold text-white" data-id="element-131" data-mp="3gg118925080a">IMPLANT DECISION SYSTEM™</p>
      <p className="mt-2 text-sm" data-id="element-132" data-mp="32ovzn1f7l5nb">© 2026 · All Rights Reserved.</p>
      <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-plum-200/80" data-id="element-133" data-mp="36p6bgupomqa3">
        Educational material only. This product does not replace diagnosis, formal clinical education, hands-on
        training, professional supervision, or individual clinical judgment. Treatment decisions must be based on
        comprehensive patient assessment, appropriate professional training, and applicable standards and protocols.
      </p>
    </footer>;
}